const config = {
  googleOAuthClientID:
    "1070279089411-kbqu6p3nct35dr7acgbb3fi88ohmqdkk.apps.googleusercontent.com",
  facebookOAuthAppId: "2562816930443535"
};

module.exports = { config };
